var chunkMapping = {
	"336": [
		336
	],
	"547": [
		547
	],
	"926": [
		926
	],
	"1021": [
		1021
	],
	"1767": [
		1767
	],
	"2695": [
		2695
	],
	"3105": [
		3105
	],
	"5811": [
		5811
	],
	"6918": [
		6918
	],
	"7787": [
		7787
	],
	"8371": [
		8371
	],
	"8678": [
		8678
	]
};
var idToExternalAndNameMapping = {
	"336": [
		"default",
		"./RecommendationSection",
		9126
	],
	"547": [
		"default",
		"./BrandVideoSection",
		9126
	],
	"926": [
		"default",
		"./RecommendationsMDSection",
		9126
	],
	"1021": [
		"default",
		"./MarketingBannerSection",
		9126
	],
	"1767": [
		"default",
		"./CustomerService",
		9126
	],
	"2695": [
		"default",
		"./KPopSection",
		9126
	],
	"3105": [
		"default",
		"./HeroBannerSection",
		9126
	],
	"5811": [
		"default",
		"./OurPicksSection",
		9126
	],
	"6918": [
		"default",
		"./BestSellerSection",
		9126
	],
	"7787": [
		"default",
		"./FeaturedBrandsSection",
		9126
	],
	"8371": [
		"default",
		"./NoticeSection",
		9126
	],
	"8678": [
		"default",
		"./CartContainer",
		577
	]
};
var idToRemoteMap = {
	"336": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"547": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"926": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"1021": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"1767": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"2695": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"3105": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"5811": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"6918": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"7787": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"8371": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 9126
		}
	],
	"8678": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 577
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}